import React from "react";
import { SOURCE_TYPE_DISPLAY_VALUE, buildContentFeedUrl } from "utils/ContentFeedFormat";

import "./ContentFeedType.css";

export default function ContentFeedType({ dependentValues }) {
	const { format } = dependentValues;
	const url = buildContentFeedUrl(dependentValues);

	return (
		<a
			href={url}
			target="_blank"
			rel="noopener noreferrer"
			className="content-feed-type-link"
		>
			{SOURCE_TYPE_DISPLAY_VALUE[format]}
		</a>
	);
}

ContentFeedType.displayName = "ContentFeedType";

